import { TuiInput, TuiTextfield } from '@taiga-ui/core';
import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  input,
  OnInit,
} from '@angular/core';
import {
  FormBuilder,
  FormGroupDirective,
  ReactiveFormsModule,
} from '@angular/forms';
import { OutkeepPermissionService } from '@core/services/permission/outkeep-permission.service';
import { RequestService } from '@core/services/request/request.service';
import { TranslatePipe } from '@ngx-translate/core';

enum FormFields {
  ShipmentDocsAddress = 'shipmentDocsAddress',
  Timezone = 'timezone',
}

@Component({
  selector: 'x-request-form-common-additional-data',
  imports: [TuiTextfield, ReactiveFormsModule, TuiInput, TranslatePipe],
  templateUrl: './request-form-common-additional-data.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RequestFormCommonAdditionalDataComponent implements OnInit {
  protected readonly permissionService = inject(OutkeepPermissionService);
  protected readonly FormFields = FormFields;
  private readonly formBuilder = inject(FormBuilder);
  private readonly parentForm = inject(FormGroupDirective);
  private readonly requestService = inject(RequestService);
  protected formGroup = this.formBuilder.group({
    [FormFields.ShipmentDocsAddress]: '',
    [FormFields.Timezone]: '',
  });

  $readOnly = input<boolean>(false, { alias: 'readOnly' });

  constructor() {
    effect(() => {
      if (this.$readOnly()) {
        this.formGroup.disable();
      }
    });
  }

  ngOnInit(): void {
    this.formGroup.patchValue(this.requestService.$request());
    this.parentForm.form.addControl('additional-data', this.formGroup);
  }
}
